/* * @Author: yezs * @Date: 2022-04-18 17:46:56 * @Last Modified by: yezs * @Last Modified time: 2022-04-24 16:07:20 */

<template>
  <div v-loading="loading">
    <div :class="['nav-tab', isApp ? 'no-header' : '']">
      <div :class="active == 0 ? 'on' : ''" @click="selectTab(0, 'Morning')">早班</div>
      <div :class="active == 1 ? 'on' : ''" @click="selectTab(1, 'Middle')">中班</div>
      <div :class="active == 2 ? 'on' : ''" @click="selectTab(2, 'Night')">晚班</div>
    </div>
    <div class="content">
      <div class="content-item">
        <div class="basic">
          <span class="title">基本信息</span>
          <div class="message">
            <van-form>
              <div class="select">
                <span>交班时间</span>
                <div>
                  <el-date-picker
                    type="datetime"
                    placeholder="选择日期"
                    v-model="formData.CDate"
                    :disabled="isEdit"
                    style="width: 100%"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                  ></el-date-picker>
                </div>
              </div>
              <div class="select">
                <span>楼层</span>
                <div>
                  <el-select v-model="formData.FloorIds" placeholder="请选择" :disabled="isEdit" multiple @change="selectFloor">
                    <el-option v-for="item in columns" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                  </el-select>
                </div>
              </div>

              <template v-if="$store.state.floorShiftValue === 1 && type">
                <van-field v-model="formData[activeName].ElderlyTotal" type="number" name="应住人数" label="应住人数" placeholder="请输入" />
                <van-field v-model="formData[activeName].Actual" type="number" name="实际人数" label="实际人数" placeholder="请输入" />
                <van-field v-model="formData[activeName].NewAdmission" type="number" name="新入住" label="新入住" placeholder="请输入" />

                <van-field v-model="formData[activeName].GoOut" type="number" name="外出" label="外出" placeholder="请输入" />

                <van-field v-model="formData[activeName].Discharged" type="number" name="离院" label="离院" placeholder="请输入" />
                <van-field v-model="formData[activeName].Carelevel0" type="number" name="照护0级" label="照护0级" placeholder="请输入" />
                <van-field v-model="formData[activeName].Carelevel1" type="number" name="照护1级" label="照护1级" placeholder="请输入" />
                <van-field v-model="formData[activeName].Carelevel2" type="number" name="照护2级" label="照护2级" placeholder="请输入" />
                <van-field v-model="formData[activeName].Carelevel3" type="number" name="照护3级" label="照护3级" placeholder="请输入" />
                <van-field v-model="formData[activeName].Carelevel4" type="number" name="照护4级" label="照护4级" placeholder="请输入" />
                <van-field v-model="formData[activeName].ExclusiveCare" type="number" name="专护" label="专护" placeholder="请输入" />
              </template>

              <template v-else-if="$store.state.floorShiftValue === 2 && type">
                <van-field v-model="formData[activeName].NewAdmission" type="number" name="新入住" label="新入住" placeholder="请输入" />
                <van-field v-model="formData[activeName].Discharged" type="number" name="退住" label="退住" placeholder="请输入" />
                <van-field v-model="formData[activeName].Die" type="number" name="离世" label="离世" placeholder="请输入" />
                <van-field v-model="formData[activeName].ElderlyTotal" type="number" name="总人数" label="总人数" placeholder="请输入" />
                <van-field v-model="formData[activeName].Tdischarge" type="number" name="暂离院" label="暂离院" placeholder="请输入" />
                <van-field v-model="formData[activeName].Aleave" type="number" name="请假" label="请假" placeholder="请输入" />
                <van-field v-model="formData[activeName].Tleave" type="number" name="当日请假" label="当日请假" placeholder="请输入" />

                <van-field v-model="formData[activeName].Gdoctor" type="number" name="就医" label="就医" placeholder="请输入" />

                <van-field v-model="formData[activeName].TGdoctor" type="number" name="当日就医" label="当日就医" placeholder="请输入" />

                <van-field v-model="formData[activeName].Actual" type="number" name="当日人数" label="当日人数" placeholder="请输入" />

                <van-field v-model="formData[activeName].Returnees" type="number" name="返院人数" label="返院人数" placeholder="请输入" />
                <van-field v-model="formData[activeName].LReturns" type="number" name="请假返院" label="请假返院" placeholder="请输入" />
                <van-field v-model="formData[activeName].GdoctorReturns" type="number" name="就医返院" label="就医返院" placeholder="请输入" />
                <van-field v-model="formData[activeName].Pdrugs" type="number" name="精神类药" label="精神类药" placeholder="请输入" />
                <van-field v-model="formData[activeName].Adrugs" type="number" name="抗凝类药" label="抗凝类药" placeholder="请输入" />
                <van-field v-model="formData[activeName].ACatheter" type="number" name="留置尿管" label="留置尿管" placeholder="请输入" />
                <van-field v-model="formData[activeName].Nftube" type="number" name="鼻饲管" label="鼻饲管" placeholder="请输入" />
                <van-field v-model="formData[activeName].OxygenUp" type="number" name="吸氧" label="吸氧" placeholder="请输入" />
                <van-field v-model="formData[activeName].CriticalIllness" type="number" name="急危重症" label="急危重症" placeholder="请输入" />
              </template>

              <template v-else>
                <van-field v-model="formData[activeName].ElderlyTotal" type="number" name="总人数" label="应住人数" placeholder="请输入" />
                <van-field v-model="formData[activeName].NewAdmission" type="number" name="新入住" label="新入住" placeholder="请输入" />
                <van-field v-model="formData[activeName].Die" type="number" name="离世" label="离世" placeholder="请输入" />
                <van-field v-model="formData[activeName].Hospitalized" type="number" name="住院" label="住院" placeholder="请输入" />
                <van-field v-model="formData[activeName].GoOut" type="number" name="外出" label="外出" placeholder="请输入" />
                <van-field v-model="formData[activeName].Departure" type="number" name="120送院" label="120送院" placeholder="请输入" />
                <van-field v-model="formData[activeName].QuarantinePeople" type="number" name="隔离人数" label="隔离人数" placeholder="请输入" />
                <van-field v-model="formData[activeName].Actual" type="number" name="实际人数" label="实际人数" placeholder="请输入" />
              </template>
            </van-form>
          </div>
        </div>
        <div class="basic">
          <span class="title">添加信息</span>
          <div class="message" v-for="(item, index) in formData[activeName].ShiftModels" :key="index">
            <van-form>
              <van-field v-model="item.RoomNo" name="房间号" label="房间号" placeholder="请输入" />
              <van-field v-model="item.PName" name="姓名" label="姓名" placeholder="请输入" />
              <van-field v-model="item.Note" rows="1" autosize type="textarea" name="交班内容" label="交班内容" placeholder="请输入" />
            </van-form>
            <div class="add-btn">
              <div class="delete" v-if="formData[activeName].ShiftModels.length > 1" @click="deleteItem(formData[activeName].ShiftModels, index)">删除</div>
              <div class="add" @click="add(formData[activeName].ShiftModels)">添加</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submin" @click="subMin">提交</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const baseForm = {
  Actual: null,
  Departure: null,
  Die: null,
  Discharged: null,
  ElderlyTotal: null,
  GoOut: null,
  Hospitalized: null,
  IsEdit: null,
  NewAdmission: null,
  NursingHandoverId: null,
  QuarantinePeople: null,
  ShiftId: null,
  ShiftModels: [{ Note: '', RoomNo: '', PName: '' }],
  Discharged: null,
  Carelevel0: null,
  Carelevel1: null,
  Carelevel2: null,
  Carelevel3: null,
  Carelevel4: null,
  ExclusiveCare: null,
  Tdischarge: null,
  Aleave: null,
  Tleave: null,
  Tleave: null,
  Gdoctor: null,
  GdoctorReturns: null,
  Returnees: null,
  LReturns: null,
  Pdrugs: null,
  Adrugs: null,
  ACatheter: null,
  Nftube: null,
  OxygenUp: null,
  CriticalIllness: null,
  TGdoctor: null
}
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      isApp: true,
      loading: false,
      active: '0',
      type: 0,
      activeName: 'Morning',
      showPicker: false,
      showFloor: false,
      columns: [],
      formData: {
        CDate: this.dateFormats(),
        FloorIds: null,
        FloorNames: null,
        Id: null,
        Middle: JSON.parse(JSON.stringify(baseForm)),
        Morning: JSON.parse(JSON.stringify(baseForm)),
        Night: JSON.parse(JSON.stringify(baseForm)),
        RecordDate: null
      },
      isEdit: false
    }
  },
  filters: {
    dateFormat: function (dateStr, pattern = '') {
      var dt = new Date(dateStr)
      var yy = dt.getFullYear()
      var mm = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1
      var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds()
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return yy + '-' + mm + '-' + dd
      } else {
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
      }
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['user'])
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 初始化选择时间 默认当天
    dateFormats: function () {
      var dt = new Date()
      var yy = dt.getFullYear()
      var mm = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1
      var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds()

      return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
    },
    // 获取楼层GET /api/Pad/GetFloorDrop
    gerFloor() {
      this.$axios.get('/Pad/GetFloorDrop').then((response) => {
        this.columns = response.data.obj
      })
    },
    // 交班信息选择楼层
    selectFloor(e) {
      var data = e.join(',')
      this.$axios.get('/Pad/GetFloorNoUsingQty?floorIds=' + data).then((response) => {
        if (response.data.ok) {
          this.formData.Morning.ElderlyTotal = response.data.obj
          this.formData.Middle.ElderlyTotal = response.data.obj
          this.formData.Night.ElderlyTotal = response.data.obj
        } else {
        }
      })
    },
    // 删除添加信息
    deleteItem(item, index) {
      item.splice(index, 1)
    },
    // 新增添加信息
    add(item) {
      item.push({ Note: '', PName: '', RoomNo: '' })
    },
    // tab点击
    selectTab(index, name) {
      this.active = index
      this.activeName = name
    },
    // 提交
    subMin() {
      const list = this.formData[this.activeName].ShiftModels.filter((item) => item.Note || item.PName || item.RoomNo)
      if (list.length > 0) {
        this.formData[this.activeName].ShiftModels = list
      } else {
        return this.$message.error({
          message: '请填写添加信息',
          offset: 100
        })
      }
      if (this.formData.FloorIds.length === 0) {
        return this.$message.error({
          message: '请选择楼栋',
          offset: 100
        })
      }
      this.formData[this.activeName].IsEdit = this.formData.Id ? '1' : '2'
      this.formData[this.activeName].NursingHandoverId = this.formData.Id
      this.loading = true
      if (this.type) {
        //楼层交班
        this.$axios
          .post('/Pad/SaveNursingShift?cUser=' + this.user.UserName, this.formData)
          .then((response) => {
            this.$message({
              message: '提交成功！',
              type: 'success',
              offset: 100
            })
            this.loading = false
            this.$router.push({
              name: 'floorShift'
            })
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        //护士交班
        this.$axios
          .post('/Pad/SaveNursingShiftHandover?cUser=' + this.user.UserName, this.formData)
          .then((response) => {
            this.$message({
              message: '提交成功！',
              type: 'success',
              offset: 100
            })
            this.loading = false
            this.$router.push({
              name: 'nurseShiftExchange'
            })
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  },
  beforeCreate() {},
  created() {
    this.gerFloor()
    this.isEdit = Boolean(this.$route.query.isEdit)
    this.type = this.$route.query.type
    if (this.$route.query.isEdit) {
      this.formData = JSON.parse(localStorage.getItem('item'))
    }
    this.isApp = localStorage.getItem('isApp') === '0'
  }
}
</script>

<style>
.basic .van-cell {
  min-height: 50px;
  padding: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.van-field__control {
  line-height: 18px;
}
.select .el-input__inner {
  border: 0;
  font-size: 14px;
}
.select .el-tag {
  height: 18px;
  font-size: 14px;
}
.el-select {
  width: 100%;
}

.el-tag .el-select__tags-text {
  height: 14px;
  line-height: 14px;
}
</style>
<style scoped>
.nav-tab {
  width: 100%;
  height: 50px;
  background-color: #fff;
  position: fixed;
  top: 44px;
  left: 0;
  display: flex;
  box-sizing: border-box;
  padding-top: 12px;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.no-header {
  top: 0px !important;
}

.nav-tab div {
  font-size: 16px;
  color: #0a0e10;
  padding: 0 20px;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}
.nav-tab .on::after {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 0;
  content: '';
  width: 40px;
  height: 2px;
  border-radius: 2px;
  background-color: #029fd1;
}
.content {
  width: 100%;
  padding: 62px 15px 65px 15px;
  box-sizing: border-box;
}
.content-item {
  display: flex;
  flex-direction: column;
}
.basic {
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 12px 0 12px;
  margin-bottom: 12px;
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.add-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
}
.add-btn div {
  width: 64px;
  height: 32px;
  box-sizing: border-box;
  border: 1px solid #c7c9cc;
  border-radius: 16px;
  font-size: 14px;
  color: #0a0e10;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}
.add-btn .add {
  border-color: #029fd1;
  color: #029fd1;
}
.select {
  width: 100%;
  min-height: 45px;
  display: flex;
  align-items: center;
  font-size: 15px;
  border-bottom: 1px solid #ebedf0;
}
.select > span {
  width: 88px;
}
.select > div {
  flex: 1;
}
.submin {
  width: 100%;
  height: 47px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: #029fd1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  color: #fff;
}

.van-field__control {
  padding-top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/shiftExchange/addShift.vue